import { render, staticRenderFns } from "./bottomLeft3.vue?vue&type=template&id=52b765da&scoped=true&"
import script from "./bottomLeft3.vue?vue&type=script&lang=js&"
export * from "./bottomLeft3.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft3.vue?vue&type=style&index=0&id=52b765da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b765da",
  null
  
)

export default component.exports